/* eslint-disable import/prefer-default-export */
function debounce(inputFunction, timeToWaitBeforeFiringInMs = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      inputFunction.apply(this, args);
    }, timeToWaitBeforeFiringInMs);
  };
}

export function stopTyping(node) {
  const handleKeyup = debounce((event: KeyboardEvent) => {
    if (node.contains(event.target)) {
      node.dispatchEvent(new CustomEvent('stopTyping'));
    }
  }, 500);

  document.addEventListener('keyup', handleKeyup, true);

  return {
    destroy() {
      document.removeEventListener('keyup', handleKeyup, true);
    }
  };
}
